import { FetchCustomTypesParams } from "PFCore/services/custom_types";
import { CustomValueScope, Id } from "PFTypes";

export const customTypeKeys = {
  all: () => ["customTypes"],
  single: (id) => [...customTypeKeys.all(), id],
  list: (params?: FetchCustomTypesParams) => [...customTypeKeys.all(), "list", params]
};

export const customValueKeys = {
  all: () => ["customValues"],
  singleUnscoped: (id: Id) => [...customValueKeys.all(), CustomValueScope.Unscoped, id],
  singleInProfileScope: (customValueId: Id, profileId: Id) => [
    ...customValueKeys.all(),
    CustomValueScope.Profile,
    customValueId,
    profileId
  ],
  customValueActivityConnection: (customValueId: Id, activityId: Id) => [
    ...customValueKeys.all(),
    CustomValueScope.Activity,
    customValueId,
    activityId
  ],
  customValueInsights: (id: Id) => [...customValueKeys.all(), "insights", id],
  customValueParentsAndChildren: (id: Id) => [...customValueKeys.all(), "parentsAndChildren", id]
};
